// Hårda valideringsregler: obligatoriska punkter i byggherrens checklista (Dok 53)
// måste vara OK eller N/A med motivering innan ett skede kan avslutas.
import { supabase } from "@/integrations/supabase/client";
import { PROJECT_PHASE_TO_CHECKLIST_PHASE } from "@/lib/basProcess/byggherreDocs";

export interface ChecklistBlocker {
  id: string;
  activity: string;
  status: string;
  reason: string;
}

interface Row {
  id: string;
  activity: string;
  status: string;
  note: string | null;
  phase: string;
  required: boolean | null;
}

/** Punkter som spärrar avslut av ett projektskede. */
export const fetchPhaseBlockers = async (
  projectId: string,
  projectPhaseKey?: string | null
): Promise<ChecklistBlocker[]> => {
  const checklistPhase = projectPhaseKey
    ? PROJECT_PHASE_TO_CHECKLIST_PHASE[projectPhaseKey]
    : undefined;
  if (!checklistPhase) return [];

  const { data } = await supabase
    .from("byggherre_checklist_items")
    .select("id, activity, status, note, phase, required")
    .eq("project_id", projectId)
    .eq("phase", checklistPhase)
    .eq("required", true);

  return ((data as Row[] | null) ?? []).flatMap((row) => {
    if (row.status === "ok") return [];
    if (row.status === "ej_aktuell") {
      return (row.note || "").trim().length >= 5
        ? []
        : [
            {
              id: row.id,
              activity: row.activity,
              status: row.status,
              reason: "N/A saknar motivering",
            },
          ];
    }
    return [
      {
        id: row.id,
        activity: row.activity,
        status: row.status,
        reason: row.status === "ej_ok" ? "Markerad EJ OK" : "Inte kvitterad som OK eller N/A",
      },
    ];
  });
};
